"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptTaskViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class ScriptTaskViewModel extends ActivityViewModel_1.ActivityViewModel {
    constructor(scriptTask, processModel) {
        super(scriptTask, processModel);
        this.script = scriptTask.script;
    }
}
exports.ScriptTaskViewModel = ScriptTaskViewModel;
//# sourceMappingURL=ScriptTaskViewModel.js.map